import { Modal, styled } from "@mui/material";
import { IStyledModalProps } from "./types";

const widthForSize = (size?: "sm" | "md"): number => (size === "sm" ? 460 : 800);

const StyledModal = styled(Modal, {
    shouldForwardProp: (prop) => prop !== "size",
})<IStyledModalProps>(({ theme, size }) => ({
    "& .MuiPaper-root": {
        padding: theme.spacing(3),
        borderRadius: (theme as any).shape.border.general.radius[4],
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        // Responsivo: nunca ultrapassa a viewport; rola internamente em conteúdos altos.
        width: `min(${widthForSize(size)}px, calc(100vw - 32px))`,
        maxHeight: "calc(100vh - 32px)",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        backgroundColor: (theme as any).palette.neutral.darkest,
    },
}))

export { StyledModal }